import { render, staticRenderFns } from "./AppConfigSection.vue?vue&type=template&id=019948d9&scoped=true&"
import script from "./AppConfigSection.vue?vue&type=script&lang=js&"
export * from "./AppConfigSection.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigSection.vue?vue&type=style&index=0&id=019948d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019948d9",
  null
  
)

export default component.exports